export interface ICustomiseMailStepModel {
    writePersonalMessage: boolean;
    personalMessage: string;
    addMedia: boolean;
    useGif: boolean;
    mediaUrl: string;
    userMedias: Array<string>;
}

export class CustomiseMailStepModel implements ICustomiseMailStepModel {
    writePersonalMessage: boolean;
    personalMessage: string;
    addMedia: boolean;
    useGif: boolean;
    mediaUrl: string;
    userMedias: Array<string>;

    constructor() {
        this.writePersonalMessage = true;
        this.personalMessage = "";
        this.addMedia = false;
        this.useGif = true;
        this.mediaUrl = "";
        this.userMedias = new Array<string>();
    }

    static isValid(model: ICustomiseMailStepModel): boolean {
        if (model.writePersonalMessage && !model.personalMessage.trim()) {
            return false;
        }

        if (model.addMedia && !model.mediaUrl.trim()) {
            return false;
        }

        return true;
    }
}